import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";

import { ReactComponent as ClockIcon } from "../../../../images/state/clock_24.svg";
import { ReactComponent as EditIcon } from "../../../../images/state/edit_24.svg";
import { ReactComponent as ExpertIcon } from "../../../../images/state/expert_24.svg";
import { ReactComponent as DoDisturbIcon } from "../../../../images/state/do_disturb_24.svg";
import { ReactComponent as CheckIcon } from "../../../../images/state/check_circle_24.svg";

const useStyles = makeStyles({
  cardTitle: {
    padding: "8px 0",
    borderBottom: "1px dashed #CACCD1"
  },
  fonts: {
    fontSize: 16,
    lineHeight: "24px"
  },
  statusBlock: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 0"
  },
  simpleChip: {
    backgroundColor: "rgba(0, 0, 143, 0.75)",
    color: "#fff"
  },
  hourChip: {
    backgroundColor: "rgba(48, 73, 103, 0.8)",
    color: "#fff",
    fontWeight: "bold",
    "& .MuiAvatar-colorDefault": {
      backgroundColor: "transparent"
    }
  },
  statusChip: {
    color: "#fff",
    textTransform: "uppercase",
    "& .MuiAvatar-colorDefault": {
      backgroundColor: "transparent"
    },
    "& g": {
      "& path": {
        fill: "#fff"
      }
    }
  }
});

export default function Title({ item, type }) {
  const classes = useStyles();

  const statusColor = statusId => {
    switch (statusId) {
      case 1:
        return "rgba(119, 136, 153, 0.7)";
      case 3:
        return "rgba(255, 149, 0, 0.7)";
      case 4:
        return "rgba(241, 84, 84, 0.8)";
      case 6:
        return "rgba(133, 196, 70, 0.8)";
      default:
        return "rgba(0, 127, 189, 0.7)";
    }
  };

  const statusIcon = statusId => {
    switch (statusId) {
      case 1:
        return <EditIcon />;
      case 3:
        return <ExpertIcon />;
      case 4:
        return <DoDisturbIcon />;
      case 6:
        return <CheckIcon />;
      default:
        return <ClockIcon />;
    }
  };

  return (
    <div className={classes.cardTitle}>
      <Typography className={classes.fonts} align="center">
        {item.name}
      </Typography>
      <div className={classes.statusBlock}>
        <Chip
          avatar={
            type === "module" || type === "program" ? (
              <Avatar>
                <ClockIcon />
              </Avatar>
            ) : null
          }
          label={
            type === "module" || type === "program"
              ? item.duration
              : `${item.code} | ${item.typeName} `
          }
          size="small"
          className={
            type === "module" || type === "program"
              ? classes.hourChip
              : classes.simpleChip
          }
        />
        <Chip
          avatar={<Avatar>{statusIcon(item.statusId)}</Avatar>}
          label={item && item.statusName}
          size="small"
          className={classes.statusChip}
          style={{ backgroundColor: statusColor(item.statusId) }}
        />
      </div>
    </div>
  );
}
